import React, { Component } from 'react'
import { connect } from 'react-redux';
import classnames from "classnames";
import { get } from 'lodash'

import Button from './../shared/Button';
import TutorialStep1 from './TutorialStep1';
import TutorialStep2 from './TutorialStep2';
import TutorialStep3 from './TutorialStep3';
import TutorialStep4 from './TutorialStep4';
import TutorialStep5 from './TutorialStep5';
import TutorialStep6 from './TutorialStep6';
import TutorialStep7 from './TutorialStep7';
import TutorialStep8 from './TutorialStep8';
import TutorialStep9 from './TutorialStep9';
import IntroModal from './IntroModal';

import { profileUpdateStages, profileFetchIfNeeded, profileInvalidate } from '../../store/profile/actions';

import baseStyles from 'custom/base.styl';

const COUNT_STEP = 9;
const STRUCTURE_STEP = {
  1: TutorialStep1,
  2: TutorialStep2,
  3: TutorialStep3,
  4: TutorialStep4,
  5: TutorialStep5,
  6: TutorialStep6,
  7: TutorialStep7,
  8: TutorialStep8,
  9: TutorialStep9,
};

const TITLE_STEP = {
  1: 'Take some time. Do it diligently.',
  2: 'Follow the Instructions',
  3: 'Sources',
  4: 'Plagiarism',
  5: 'Structure',
  6: 'Language',
  7: 'Format',
  8: 'Working on STEM orders',
  9: 'Working with dashboards',
};

class PageTutorial extends Component {
  constructor(props) {
    super(props)

    this.state = {
      curStep: 1,
    }

    this.onStepNext = this.onStepNext.bind(this)
    this.onStepPrev = this.onStepPrev.bind(this)
    this.onComplete = this.onComplete.bind(this)
    this.onStart = this.onStart.bind(this);
  }

  componentDidMount() {
    const { load } = this.props;
    load();
  }

  onStepNext() {
    const { curStep } = this.state;
    this.setState({
      curStep: (curStep + 1),
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onStepPrev() {
    const { curStep } = this.state;
    this.setState({
      curStep: curStep - 1,
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onComplete() {
    const { nextStage, location, history } = this.props;
    if (location.pathname === '/repeat-tutorial') {
      history.push('/academic-test');
      return;
    }
    nextStage();
  }

  onStart() {
    const { nextStage } = this.props;
    nextStage();
  }

  renderStep() {
    const { curStep } = this.state;
    const ActiveStep = STRUCTURE_STEP[curStep];

    return (
      <ActiveStep />
    );
  }

  render() {
    const { location, subjectType } = this.props;
    const { curStep } = this.state;
    const showModal = location.pathname === '/tutorial-start';
    const nextDisabled = curStep >= COUNT_STEP;
    const prevDisabled = curStep <= 1;

    return (
      <div className={baseStyles.centered}>
        <h5 className={baseStyles.tutorial_step}>{curStep} step from {COUNT_STEP}</h5>
        <h1 className={baseStyles.tutorial_title}>{TITLE_STEP[curStep]}</h1>
        <div className={classnames(baseStyles.tutorial_content)}>
          <span className={baseStyles.tutorial_line}>
            <i className={classnames(baseStyles.tutorial_line_step, { [baseStyles.tutorial_line_full]: COUNT_STEP === curStep })} style={{ width: `${(100 / COUNT_STEP) * curStep}%` }} />
          </span>

          {this.renderStep()}

          <div className={baseStyles.tutorial_footer}>
            <Button onClick={this.onStepPrev} disabled={prevDisabled}>Previous</Button>
            {!nextDisabled &&
              <Button onClick={this.onStepNext} disabled={nextDisabled}>Next</Button>
            }
            {nextDisabled &&
              <Button onClick={this.onComplete}>Complete tutorial</Button>
            }
            {!!showModal && <IntroModal onStart={this.onStart} subjectType={subjectType} />}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const profile = state.profile;
  const subjectType = get(profile.data, 'user.profile.subject_type');

  return {
    subjectType,
  };
};

const mapDispatchToProps = dispatch => ({
  nextStage: () => dispatch(profileUpdateStages()),
  load: () => {
    dispatch(profileInvalidate());
    dispatch(profileFetchIfNeeded());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PageTutorial);




// WEBPACK FOOTER //
// ./src/components/Tutorial/PageTutorial.js